import React from 'react';
import { Link } from 'react-router-dom';

const sections = [
  {
    title: '1. Aceptación de los Términos',
    body: `Al acceder y utilizar los servicios de IntegraMente aceptas cumplir con estos términos y condiciones. Si no estás de acuerdo con alguna parte, no podrás utilizar nuestros servicios.`,
  },
  {
    title: '2. Servicios ofrecidos',
    body: `IntegraMente facilita la gestión de citas entre pacientes y profesionales de la salud. El detalle de cada servicio está disponible en nuestros canales oficiales.`,
    list: [
      'Programación y administración de reservas',
      'Recordatorios automáticos de sesiones',
      'Comunicación segura con el equipo profesional',
      'Gestión básica de antecedentes necesarios para la atención',
    ],
  },
  {
    title: '3. Registro de usuario',
    body: `Para ciertas funcionalidades deberás registrarte con datos veraces y mantenerlos actualizados. Eres responsable de resguardar tus credenciales y de toda actividad realizada con tu cuenta.`,
  },
  {
    title: '4. Cancelación de citas',
    body: `Puedes reagendar o cancelar con al menos 24 horas de anticipación. Las anulaciones fuera de plazo podrían generar cargos según la política del profesional o centro.`,
  },
  {
    title: '5. Limitación de responsabilidad',
    body: `IntegraMente actúa como plataforma de coordinación. Cada profesional es responsable de la calidad de los servicios prestados y de la información clínica que comparte.`,
  },
  {
    title: '6. Modificaciones',
    body: `Podemos actualizar estos términos para reflejar cambios legales o de servicio. Publicaremos la fecha de la última modificación y el uso continuo implicará la aceptación de los nuevos términos.`,
  },
];

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-slate-50 py-16 sm:py-20">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6 lg:px-8">
        <div className="mb-6 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.3em] text-blue-500">
          <span>Términos Legales</span>
          <span className="text-slate-400">•</span>
          <span>IntegraMente HwH</span>
        </div>

        <div className="overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-[0_30px_60px_rgba(15,23,42,0.08)]">
          <div className="border-b border-slate-100 bg-slate-900/95 px-8 py-10 text-white">
            <p className="text-sm font-medium uppercase tracking-[0.32em] text-slate-400">Documento oficial</p>
            <h1 className="mt-3 text-3xl font-semibold leading-tight sm:text-4xl">Términos y condiciones de uso</h1>
            <p className="mt-6 inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-xs font-medium uppercase tracking-[0.25em] text-slate-200">
              Última actualización · 22 de agosto de 2024
            </p>
          </div>

          <div className="px-6 py-10 sm:px-10 sm:py-12 lg:px-14 lg:py-14">
            <p className="text-sm leading-relaxed text-slate-600">
              Estos términos regulan el acceso y uso de la plataforma IntegraMente HwH. Al continuar navegando o utilizar nuestras funcionalidades aceptas las condiciones descritas a continuación.
            </p>

            <div className="mt-10 space-y-10">
              {sections.map((section) => (
                <section key={section.title} className="space-y-4">
                  <h2 className="text-lg font-semibold text-slate-900 sm:text-xl">{section.title}</h2>
                  <p className="text-sm leading-relaxed text-slate-600">{section.body}</p>
                  {section.list && (
                    <ul className="ml-4 list-disc space-y-2 text-sm text-slate-600">
                      {section.list.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  )}
                </section>
              ))}
            </div>

            <div className="mt-12 rounded-2xl border border-slate-200 bg-slate-50/80 px-6 py-6 text-sm text-slate-600">
              Si tienes dudas o deseas ejercer tus derechos, escríbenos mediante nuestro
              {' '}
              <Link to="/contacto" className="font-semibold text-blue-600 underline-offset-4 hover:text-blue-700 hover:underline">
                formulario de contacto
              </Link>
              .
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;


